import React from "react";
import { Survey, SelectionStats, SurveySegment, ThemeQuestionData } from "../../../amorg-common";
import { Button } from "../../../designSystem/button/Button";
import { ListRowWithChildren } from "../../../designSystem/compositeComponents/ListRow";
import { OnOff } from "../../../designSystem/inputs/OnOff";
import { QuestionPanel } from "./QuestionPanel";
import { RadialPctChart } from "../../../designSystem/graphs/RadialPctChart";
import { AnswerRatioVerticalGraph } from "./AnswerRatioVerticalGraph";
import { GroupedAnswerRatioVerticalGraph } from "./GroupedAnswerRatioVerticalGraph";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";

type QuestionSummaryPanelProps = {
    survey:Survey,
    siteId:string,
    header:React.ReactNode,
    summaryStats:SelectionStats,
    questions:ThemeQuestionData[],
    segmentFilter:SurveySegment[][],
    showComments:boolean,
}
export function QuestionSummaryPanel(props:QuestionSummaryPanelProps): JSX.Element 
{
    const [expanded, setExpanded] = React.useState(false);
    const [showDetails, setShowDetails] = React.useState(false);

    return (
        <ListRowWithChildren styleVariant="neutral" sizeVariant="medium" expanded={expanded}
            content={
                <div style={{display:'flex', justifyContent:'space-between'}}>
                <div style={{display:'flex', width:200}}>
                    <RadialPctChart pct={props.summaryStats.agreePlusPct} />
                </div>

                <div style={{display:'flex', flexDirection:'column', flexGrow:1}}>
                    <div style={{display:'flex', justifyContent:'space-between'}}>
                        {props.header}
                        <Flex gap={4}>
                            {'Vis detaljer'}
                            <OnOff active={showDetails} onClick={() => setShowDetails(!showDetails)} />
                        </Flex>
                    </div>

                    
                    {showDetails
                        ? <AnswerRatioVerticalGraph summaryStats={props.summaryStats} />
                        : <GroupedAnswerRatioVerticalGraph summaryStats={props.summaryStats} />
                    }

                    {/* {showDetails
                        ? <AnswerRatioGraph data={props.summaryStats.data} heightPx={40} />	
                        : <GroupedAnswerRatioGraph data={props.summaryStats.data} heightPx={40} />
                    } */}


                    <div style={{display:'flex', justifyContent:'flex-end', gap:10}}>
                        <Button variant='text'
                            icon={ expanded ? 'arrows_chevron_chevronUp' : 'arrows_chevron_chevronDown' } onClick={() => setExpanded(!expanded)} />
                    </div>
                </div>
                </div>
            }
            childRows={
                <>
                    {props.questions.map((q, i) =>
                        <QuestionPanel key={i}
                            siteId={props.siteId}
                            details={q}
                            surveyId={props.survey.id}
                            segmentFilter={props.segmentFilter}
                            showCommentsButton={props.showComments}
                            showDetails={showDetails} />
                    )}
                </>
            } 
        />
    );
}